import React from 'react';
import s from './style.module.sass';

export default function BackHome() {
    return (
        <button className={s.btn_home}>Back home</button>
    )
}
